import PropTypes from "prop-types";

const CampaignGroupPropType = PropTypes.shape({
  actual_savings: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  add_weeks: PropTypes.bool,
  add_weeks_link: PropTypes.string,
  apply_coupon_link: PropTypes.string,
  eligible_to_add_weeks: PropTypes.bool,
  eligible_impression_boosts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      impression_quantity: PropTypes.number,
      cost: PropTypes.number
    })
  ),
  eligible_to_purchase_impression_boost: PropTypes.bool,
  impression_boost_purchase_link: PropTypes.string,
  admin_dropdown_links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      link_options: PropTypes.shape({
        method: PropTypes.string,
        target: PropTypes.string
      }),
      modal_data: PropTypes.shape({
        modal_type: PropTypes.string,
        text: PropTypes.string
      })
    })
  ),
  campaign_results_admin_links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      link_options: PropTypes.shape({
        method: PropTypes.string,
        target: PropTypes.string
      }),
      modal_data: PropTypes.shape({
        modal_type: PropTypes.string,
        text: PropTypes.string
      })
    })
  ),
  bundle_id: PropTypes.number,
  bundle_link: PropTypes.string,
  campaign_id: PropTypes.number,
  campaign_label: PropTypes.string,
  fetch_campaign_packages_path: PropTypes.string,
  campaign_type_snake: PropTypes.string,
  billable_credit_cards: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
  attached_coupons: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      discount_percent: PropTypes.number,
      discount_cents: PropTypes.number
    })
  ),
  site_credit_available: PropTypes.number,
  payment_method: PropTypes.string,
  compliance: PropTypes.shape({
    approved: PropTypes.bool
  }),
  display_payment_fail_button: PropTypes.bool,
  display_pixel_status: PropTypes.bool,
  display_zips: PropTypes.bool,
  display_facebook_connection_reminder: PropTypes.bool,
  edit_contacts_link: PropTypes.string,
  finish_draft_link: PropTypes.string,
  finish_and_launch_link: PropTypes.string,
  awaiting_configuration_days_remaining: PropTypes.number,
  manage_campaign_link: PropTypes.string,
  name: PropTypes.string,
  pixel_status: PropTypes.string,
  preview_image_url: PropTypes.string,
  product_label: PropTypes.string,
  target_savings: PropTypes.number,
  update_card_link: PropTypes.string,
  unique_emails: PropTypes.number,
  status: PropTypes.string,
  status_label: PropTypes.string,
  status_note: PropTypes.string,
  status_category: PropTypes.string,
  estimated_start: PropTypes.string,
  additional_info_text: PropTypes.string,
  use_funnel_v2: PropTypes.bool,
  display_pixel_code: PropTypes.bool,
  campaign_type: PropTypes.string,
  upgrade_form_link: PropTypes.string,
  preview_width: PropTypes.number,
  preview_height: PropTypes.number,
  upgradeable: PropTypes.bool,
  upgrade_package: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  upgrade_package_label: PropTypes.string,
  started_at: PropTypes.string,
  started_at_display: PropTypes.string,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      full_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    }).isRequired
  ),
  unique_contacts: PropTypes.number
});

export default CampaignGroupPropType;
